import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiHeaders } from "helper/apiHeader";
import store from "../store.js";
const globalState = store.getState().globaReducer;

const schoolCodeApi = () => {
  axios
    .get(
      `${globalState.host}${globalState.apiEnd.metaData}`,
      apiHeaders(globalState.apiTask.schoolcodelist)
    )
    .then((res) => {
      console.log("resres", res);
      if (res.data.status === "201") {
        return res;
      } else {
        console.log("API ERROR");
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export default schoolCodeApi;
